// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"M1-z","trustedRetailerTooltipWrapper":"N1-z"};